window.HRO_FUNCTIONS = [
  'Accountmanager','Accountant','Administratief medewerker','Adviseur','Analist','Architect',
  'Assistent','Auditor','Back-office medewerker','Baliemedewerker','Bedrijfsanalist',
  'Beleidsmedewerker','Bestuursadviseur','Beveiliger','Binnendienst medewerker',
  'Boekhouder','Bouwkundige','Buitendienst medewerker','Business analist',
  'Business controller','Callcenter medewerker','Chauffeur','Chemicus',
  'Commercieel medewerker','Communicatieadviseur','Compliance officer','Conciërge',
  'Consultant','Controller','Coördinator','Customer service medewerker',
  'Data analist','Data engineer','Directeur','Directiesecretaresse',
  'Doktersassistent','Elektricien','Ergotherapeut',
  'Facility manager','Financieel adviseur','Financieel analist','Financieel controller',
  'Fotograaf','Front office manager','Fysiotherapeut',
  'Gebouwbeheerder','Gebouwcoördinator','Grafisch ontwerper',
  'Helpdesk medewerker','Hoofd administratie','Hoofd financiën','Hoofd HR',
  'Hoofd ICT','Hoofd logistiek','Hoofd marketing','Hoofd sales','HR adviseur',
  'HR manager','Huishoudelijk medewerker','Huismeester',
  'ICT beheerder','ICT projectmanager','Inkoper','Inkoop manager','Inspecteur',
  'Installateur','Interieurontwerper','Interim manager','IT architect','IT consultant',
  'Juridisch adviseur','Jurist',
  'Klantenservice manager','Klantadviseur','Kwaliteitscontroleur','Kwaliteitsmanager',
  'Laborant','Leidinggevende','Logistiek manager','Logistiek medewerker','Loodgieter',
  'Maatschappelijk werker','Magazijnmedewerker','Manager','Marketeer',
  'Marketing manager','Medewerker administratie','Medewerker beveiliging',
  'Medewerker communicatie','Medewerker financiën','Medewerker ICT',
  'Medewerker inkoop','Medewerker juridische zaken','Medewerker klantenservice',
  'Medewerker logistiek','Medewerker marketing','Medewerker ondersteuning',
  'Medewerker personeelsadministratie','Medewerker personeelszaken',
  'Medewerker receptie','Medewerker sales','Medewerker sociale dienst',
  'Medewerker technische dienst','Medewerker zorg','Monteur',
  'Netwerkbeheerder','Netwerkspecialist',
  'Office manager','Operationeel manager','Organisatieadviseur','Orthopedagoog',
  'Personeelsadviseur','Planner','PR adviseur','Procurement manager',
  'Product manager','Productiemanager','Productiemedewerker','Projectleider','Projectmanager',
  'Quality assurance medewerker',
  'Receptioniste','Recruiter','Relatiemanager','Risk manager',
  'Sales manager','Secretaresse','Sector manager','Security officer',
  'Senior accountmanager','Senior adviseur','Senior analist','Senior consultant',
  'Senior developer','Senior manager','Senior projectmanager',
  'Sociaal werker','Software developer','Software engineer','Stafmedewerker',
  'Supply chain manager','Systeembeheerder',
  'Taxichauffeur','Teamcoördinator','Teamleider','Technisch adviseur',
  'Technisch directeur','Technisch medewerker','Technisch projectleider',
  'Technisch tekenaar','Telefoniste','Testmanager',
  'UX designer','UX researcher',
  'Veiligheidskundige','Verkoopmedewerker','Verpleegkundige','Vertegenwoordiger',
  'Verzorgende','Vestigingsmanager','Voorzitter',
  'Warehousing medewerker','Webdeveloper','Werkvoorbereider',
  'Zorgcoördinator','Zorgmanager'
];
